<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js';
import { sendFandomAnalyticsEvent }  from 'src/modules/fandom_analytics_module.js';


export default {
  mixins: [fandomBasicMixin],
  props: {
    identifier: {
      type: String,
      required: true
    },
    showTo: {
      type: String,
      default: 'anonymous' // anonymous, registered or all
    },
    modalSizeClass: {
      type: String,
      default: 'modal-lg'
    },
  },
  data() {
    return {
      layout: globalState.pageModel.layout,
      cookieName: `${this.identifier}_timerRegistrationCookie`
    };
  },
  mounted() {
    Vue.nextTick(() => {
      setTimeout(() => {
        this.mayOpenModal();
      }, this.getOpenDelay());
      KenwoodItaly.trackLinkVisited(`#${this.identifier}-link-from-modal`, "Interaction", "Popup Click", globalState.pageModel.main_content_name);
    });
  },
  computed: {
    mayShowToUser() {
      if (this.showTo === 'anonymous') {
        return !Fandom.isUserRegistered();
      } else if (this.showTo === 'registered') {
        return Fandom.isUserRegistered();
      } else {
        return true;
      }
    },
  },
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    applyContextToUrl: Fandom.applyContextToUrl,
    getOpenDelay: function() {
      let defaultDelay = Fandom.exists(this.content.delay) ? this.content.delay : 90000;
      let timerCookie = Fandom.readCookie(this.cookieName);
      if(timerCookie) {
        let before = new Date(timerCookie.split("=")[1]);
        let now = new Date();
        return defaultDelay - (now.getTime() - before.getTime());
      } else {
        const date = new Date();
        const expireDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, date.getHours(), date.getMinutes() + 2, date.getSeconds()).toUTCString();
        Fandom.setCookie(this.cookieName, new Date().toString(), expireDate);
        return defaultDelay;
      }
    },
    mayOpenModal: function() {
      if(this.mayShowToUser && !Fandom.readCookie(`${this.cookieName}Done`)) {
        const date = new Date();
        const expireDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, date.getHours(), date.getMinutes(), date.getSeconds()).toUTCString();
        Fandom.setCookie(`${this.cookieName}Done`, true, expireDate);
        if ((!Fandom.exists(this.content.exclude_on)) || (this.content.exclude_on.indexOf(globalState.pageModel.main_content_name) < 0)) {
            $(`#${this.identifier}-modal`).modal("show");
            sendFandomAnalyticsEvent('Invite registration modal', 'Show', null);
        } 
      }
    },
    closeModal: function() {
      Fandom.setCookie(`kenwood-italy-show-profiler-anonymous`, true);
      $(`#${this.identifier}-modal`).modal("hide");
    },
    trackingUrl(event, category, action, label) {
      sendFandomAnalyticsEvent(category, action, label);
      window.location.href = $(event.currentTarget).attr('href');
      return false;
    }
  },
};
</script>

<template>
  <div class="modal fade pr-0" tabindex="-1"  :id="`${identifier}-modal`" role="dialog" invite-registration-modal>
    <div class="modal-dialog modal-dialog-centered mx-auto" :class="modalSizeClass" role="document">
      <div class="modal-content invite-registration-modal__body">
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="invite-registration-modal__header">
          <p class="h3 text-center" v-if="content.title"> {{content.title}} </p>
          <p class="h3 text-center text-orange" v-if="content.subtitle"> {{content.subtitle}} </p>
          <stripe-header :width="12" v-else-if="content.title_composed" :content="content"></stripe-header>
          <p class="invite-registration-modal__separator">
            <span class="invite-registration-modal__separator__title">{{content.separator_text}}</span>
          </p>
        </div>
        <div v-if="content.list" class="invite-registration-modal__content px-3 px-sm-4 px-md-5">
          <div v-for="(elem, index) in content.list" :key="`list-item-${index}`" class="invite-registration-modal__content-element">
            <div class="icon">
              <svg>
                <use :xlink:href="`#${elem.icon}`"></use>
              </svg>
            </div>
            <div class="ml-3">
              <p v-html="elem.title" class="invite-registration-modal__content-element__title"></p>
              <p v-html="elem.text" class="invite-registration-modal__content-element__text"></p>
            </div>
          </div>
        </div>
        <div v-else-if="content.description" class="invite-registration-modal__content px-3 px-sm-4 px-md-5">
          <div v-html="content.description"></div>
        </div>
        <div v-if="content.button" class="py-4 py-md-5 text-center">
          <a :href="content.button.url" :target="getTarget(content.button)" class="btn" :class="content.button_class || 'btn-primary'" :id="`#${this.identifier}-link-from-modal`">
            {{content.button.title}}
          </a>
        </div>
        <template v-else>
          <div class="py-3 text-center">
            <a
              :href="applyContextToUrl('/users/sign_up')"
              class="btn btn-primary py-3 py-sm-4 px-5"
              :id="`#${this.identifier}-link-from-modal`"
              @click.prevent="trackingUrl($event, 'Invite registration modal', 'Button click', 'Sign up')"
            >
              {{ft("globals.sign_up")}}
            </a>
          </div>
          <div class="py-3 text-center invite-registration-modal__footer">
            <a href="javascript:void(0)" class="" @click="closeModal()">{{ft("globals.later")}}</a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[invite-registration-modal] {
  .invite-registration-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    z-index: 9999;

    @include media-breakpoint-down(sm) {
      display: -webkit-box;
    }
  }

  .invite-registration-modal__body {
    background-color: #fff;
    position: relative;
    a.btn {
      color: white !important;
    }
    a.invite-registration-modal__close {
      position: absolute;
      top: .3rem;
      right: .5rem;
      color: black;
      font-size: 1.5rem;
    }
  }

  .invite-registration-modal__header {
    padding-top: 2rem;
    font-family: $bressay-font;
  }

  .invite-registration-modal__separator {
    height: 1px;
    background-color: black;
    margin: 2rem 0;
    position: relative;
    span {
      padding: 0 1rem;
      background-color: white;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      font-family: $gotham-font;
      font-size: 0.75rem; /* 12/16 */
      white-space: nowrap;
    }
  }

  .invite-registration-modal__content-element {
    display: flex;
    align-items: center;
    icon, svg {
      width: 60px;
      height: 60px;
    }
    p.invite-registration-modal__content-element__title,
    p.invite-registration-modal__content-element__title > p {
      font-size: 1.375rem; /* 22/16 */
      font-family: $bressay-font;
      margin-bottom: 0;
    }
    
    p.invite-registration-modal__content-element__text {
      font-size: 0.875rem; /* 14/16 */
    }
  }

  .invite-registration-modal__footer {
    border-top: 1px solid rgba(0,0,0,0.15);
  }

  .modal-lg {
    width: 60vw;
    @include media-breakpoint-up(lg) {
      width: 38vw;
    }
  }

  .modal-dialog {
    @include media-breakpoint-down(sm) {
      width: 90vw;
    }
  }

}
</style>